// api.js - Centralized API helper untuk MIG Security

const BASE_URL = '/api';

function getToken() {
  return localStorage.getItem('mig_token');
}

async function request(method, path, body = null, isFormData = false) {
  const token = getToken();
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!isFormData) headers['Content-Type'] = 'application/json';

  const config = {
    method,
    headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  };

  const res = await fetch(`${BASE_URL}${path}`, config);
  const data = await res.json().catch(() => ({}));

  if (res.status === 401) {
    localStorage.removeItem('mig_token');
    localStorage.removeItem('mig_user');
    window.location.href = '/';
    return;
  }

  if (!res.ok) throw new Error(data.error || 'Terjadi kesalahan');
  return data;
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  delete: (path) => request('DELETE', path),
  postForm: (path, formData) => request('POST', path, formData, true),
  putForm: (path, formData) => request('PUT', path, formData, true),
};

export function saveAuth(token, user) {
  localStorage.setItem('mig_token', token);
  localStorage.setItem('mig_user', JSON.stringify(user));
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem('mig_user'));
  } catch { return null; }
}

export function logout() {
  localStorage.removeItem('mig_token');
  localStorage.removeItem('mig_user');
  window.location.href = '/';
}

export function isLoggedIn() {
  return !!getToken() && !!getUser();
}

// Format helpers
export function formatDate(d) {
  if (!d) return '-';
  return new Date(d).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatTime(d) {
  if (!d) return '-';
  return new Date(d).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' });
}

export function formatDateTime(d) {
  if (!d) return '-';
  return new Date(d).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function getRoleLabel(role) {
  const map = { admin: 'Admin', spv: 'Supervisor', anggota: 'Anggota', client: 'Client' };
  return map[role] || role;
}

export function getPriorityLabel(p) {
  const map = { urgent: 'Urgent', high: 'Tinggi', medium: 'Sedang', low: 'Rendah' };
  return map[p] || p;
}

export function getStatusLabel(s) {
  const map = { baru: 'Baru', diproses: 'Diproses', selesai: 'Selesai', ditolak: 'Ditolak', terkirim: 'Terkirim', ditinjau: 'Ditinjau', pending: 'Pending', approved: 'Disetujui', rejected: 'Ditolak' };
  return map[s] || s;
}

export function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
}
